import { Config, system } from 'styled-system';

const config: Config = {
  flexDir: {
    property: 'flexDirection',
  },
};

export const customFlexBox = system(config);
